import {
  IconNameEnum,
  useHotelsStyles,
  useModuleBEM,
} from "@b2bportal/core-themes";
import {
  CoreHotelsComponent,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import type { HotelSortOptionEnum } from "@b2bportal/core-types";
import {
  Icon,
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@b2bportal/core-ui";

import { useI18nContext } from "@hopper-b2b/i18n";
import { useHotelListSort } from "@tenant/hotels";
import { RadioGroup } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./Sort.module.scss";
import { InputButton } from "@/components/InputButton";

export type HotelListSortComponentProps = PlatformComponentProps;

export const HotelListSort = ({
  children,
  className,
}: HotelListSortComponentProps) => {
  const COMPONENT_KEY = CoreHotelsComponent.HotelListSort;
  const styles = useHotelsStyles(COMPONENT_KEY, defaultStyles);
  const [, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const { t } = useI18nContext();

  const {
    context: { selectedSort },
    handlers: { getSortLabelKey, handleSortChange },
  } = useHotelListSort();

  return (
    <Popover>
      <PopoverTrigger className={clsx(cn("sort-button"), className)}>
        <InputButton
          icon={<Icon iconName={IconNameEnum.sort} />}
          title={`${t("core-hotels.availabilityPage.sort.dropDownLabel")} ${getSortLabelKey(selectedSort)}`}
          className={cn("sort-label")}
        />
      </PopoverTrigger>
      <PopoverContent
        className={clsx(cn("sort-content"), className)}
        align="end"
      >
        <h3 className={cn("sort-title")}>
          {t("core-hotels.availabilityPage.filters.sortBy.title")}
        </h3>
        <HotelListSortOptions
          selectedSort={selectedSort}
          onChange={handleSortChange}
        />
        {children}
      </PopoverContent>
    </Popover>
  );
};

export const HotelListSortOptions = ({
  selectedSort,
  onChange,
}: {
  selectedSort: HotelSortOptionEnum;
  onChange: (value: HotelSortOptionEnum) => void;
}) => {
  const COMPONENT_KEY = CoreHotelsComponent.HotelListSort;
  const styles = useHotelsStyles(COMPONENT_KEY, defaultStyles);
  const [, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const {
    context: { sortOptions },
  } = useHotelListSort();

  return (
    <RadioGroup
      options={sortOptions}
      selectedOption={selectedSort}
      onSelectValue={onChange}
      className={cn("radio-group")}
    />
  );
};
